export default function PortalUser() {
    const name = "faraz_portaluser";
    const typeCode = -1;
    const fields = {
        "entityimage":"entityimage",
    }
    return{name, typeCode, fields}
}